import React, { useCallback, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Typography, DialogTitle, IconButton, useTheme } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRecoilValue } from "recoil";
import { IEvent, IEventSelector } from "../../../models/models";
import { EVENT_SELECTOR_FORM_INITIAL_VALUES, EVENT_SELECTOR_FORM_VALIDATION_SCHEMA } from "../../config";
import { FormAutocomplete, FormCheckbox } from "../../../common/form-fields-wrappers";
import {checkOutInEventsListState, checkOutInModeState, raFetchedDataState} from "../../state";
import useOperationTranslation from "../../../../operation/hooks/useOperationTranslation";

const EventSelector = (props: any) => {
    const { onClose, open, unavailableEvents } = props;

    const theme = useTheme();
    const {t, i18n} = useTranslation(['network', 'translation']);
    const operationTranslation = useOperationTranslation();

    // modalità attiva
    const checkOutInMode = useRecoilValue(checkOutInModeState);
    const eventOptions = useRecoilValue(checkOutInEventsListState);
    const raFetchedData = useRecoilValue(raFetchedDataState);

    const handleClose = () => {
        onClose();
    };

    const eventSelectorForm = useForm<IEventSelector>({
        defaultValues: EVENT_SELECTOR_FORM_INITIAL_VALUES,
        resolver: yupResolver(
            EVENT_SELECTOR_FORM_VALIDATION_SCHEMA
        )
    });

    const handleCreateEvent = (event: IEventSelector) => {
        const newEvent: IEvent = Object.assign({id: null, damages: []}, event);
        onClose(newEvent);
        eventSelectorForm.reset();
    };

    const getEventLabel = useCallback((opt:any) => {
        return operationTranslation(`masterDataDamage.event.${opt.code.toLowerCase().replace('.', '_')}` as any)
    }, [i18n.language])

    return (
        <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={'xs'}>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
				<Typography variant={"h6"}>
                    {t("raCheckOutIn.checkDamage.eventSelector.title")}
				</Typography>

                <IconButton onClick={handleClose} sx={{ml: theme.spacing(4), mr: "0px"}}>
                    <CloseRounded />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <form>
                    <Box>
                        <FormAutocomplete<IEventSelector>
                            name="eventName"
                            control={eventSelectorForm.control}
                            label={t("raCheckOutIn.checkDamage.eventSelector.labelEvent")}
                            fullWidth
                            options={eventOptions}
                            isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                            getOptionLabel={getEventLabel}
                            getOptionDisabled={option => unavailableEvents.includes(option?.id)}
                        />
                    </Box>
                    <Box>
                        <FormCheckbox<IEventSelector>
                            name="counterpart"
                            control={eventSelectorForm.control}
                            label={t("raCheckOutIn.checkDamage.eventSelector.labelCounterpart")}
                            color={"primary"}
                            disabled={checkOutInMode === 'out' || ((checkOutInMode === 'oprOut' || checkOutInMode === 'oprIn' || checkOutInMode === 'ddt' || checkOutInMode === 'dataUpd') && !raFetchedData.oprData?.enableCounterPart)}
                        />
                    </Box>
                </form>
            </DialogContent>

            <DialogActions>
                <Button color={"accent"} onClick={eventSelectorForm.handleSubmit(handleCreateEvent)}>{t("raCheckOutIn.checkDamage.eventSelector.continue")}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EventSelector;